import React, { useState, useEffect } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { Offcanvas, Button } from 'react-bootstrap';
import styles from '../../styles/sidebar.module.css';

import Login from '../Login/Login';
import userImage from './user.png';
import axios from '../../constents/axios';

import { FaBars, FaArrowRight, FaRegPlayCircle } from 'react-icons/fa';

const SideBar = ({ user, setUser }) => {
  const location = useLocation();

  const [showSidebar, setShowSidebar] = useState(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < 1337 : false
  );
  const [isTestOpen, setIsTestOpen] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  // Open by default on desktop, closed on mobile
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const mobile = window.innerWidth < 1337;
      setIsMobile(mobile);
      setShowSidebar(!mobile);
    }
  }, []);

  useEffect(() => {
    const onResize = () => {
      const mobile = window.innerWidth < 1337;
      setIsMobile(mobile);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    if (isLoggingOut) {
      localStorage.removeItem('adminLogin');
      setUser(null);
      setIsLoggingOut(false);
      setShowSidebar(false);
    }
  }, [isLoggingOut, setUser]);

  const handleTranscode = async () => {
    try {
      await axios.get('/transcode');
    } catch (error) {
      console.error('Error starting transcoding server:', error.message);
    }
  };

  const handleReportedQuestionsOverdue = async () => {
    try {
      const response = await axios.post('/tests/AutoOverdue', null, {
        headers: {
          'autherisation': `V9YlI4AgRJa97h9JT45acmijLliEcCEMnxZLtL7VlnWVETZuitk2MYoj0pCcrmHa` // Replace with your actual token
        }
      });
      console.log("res",response.data);
      
    } catch (error) {
      console.error('Error starting reported questions server:', error.message);
    }
  };

  const isActiveLink = (path) => location.pathname === path;
  const closeAndNavigate = () => setShowSidebar(false);

  return (
    <div className={styles.wrapper}>
      {/* Show hamburger ONLY when the drawer is closed */}
      {!showSidebar && (
        <button
          className={styles.hamburgerBtn}
          aria-label="Open menu"
          onClick={() => setShowSidebar(true)}
        >
          <FaBars />
        </button>
      )}

      <Offcanvas
        className={styles.offcanvas}
        show={showSidebar}
        onHide={() => setShowSidebar(false)}
        placement="start"
        backdrop
         enforceFocus={false}  
        restoreFocus={false}
      >
        <Offcanvas.Header closeButton className={styles.offcanvasHeader}>
          <Offcanvas.Title className={styles.offcanvasTitle}>Admin Panel</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body className={styles.offcanvasBody}>
          <nav className={styles.menu}>
            <Link
              to="/studentJourney"
              className={`${styles.menuLink} ${isActiveLink('/studentJourney') ? styles.active : ''}`}
              onClick={closeAndNavigate}
            >
              <span>Student Journey</span>
              {isActiveLink('/studentJourney') && <FaArrowRight className={styles.activeArrow} />}
            </Link>

            <Link
              to="/e-books"
              className={`${styles.menuLink} ${isActiveLink('/e-books') ? styles.active : ''}`}
              onClick={closeAndNavigate}
            >
              <span>E-Books</span>
              {isActiveLink('/e-books') && <FaArrowRight className={styles.activeArrow} />}
            </Link>

            <Link
              to="/convertStudentJourney"
              className={`${styles.menuLink} ${isActiveLink('/convertStudentJourney') ? styles.active : ''}`}
              onClick={closeAndNavigate}
            >
              <span>Conversion</span>
              {isActiveLink('/convertStudentJourney') && <FaArrowRight className={styles.activeArrow} />}
            </Link>

            <Link
              to="/reels"
              className={`${styles.menuLink} ${isActiveLink('/reels') ? styles.active : ''}`}
              onClick={closeAndNavigate}
            >
              <span>Reels</span>
              {isActiveLink('/reels') && <FaArrowRight className={styles.activeArrow} />}
            </Link>

            <Link
              to="/events"
              className={`${styles.menuLink} ${isActiveLink('/events') ? styles.active : ''}`}
              onClick={closeAndNavigate}
            >
              <span>Events</span>
              {isActiveLink('/events') && <FaArrowRight className={styles.activeArrow} />}
            </Link>

            {/* Tests dropdown */}
            <div className={styles.testDropDownWrapper} onClick={() => setIsTestOpen((p) => !p)}>
              <span className={styles.testDropDownText}>Tests</span>
              <span className={styles.testDropDownIcon}>{isTestOpen ? '▲' : '▼'}</span>
            </div>

            {isTestOpen && (
              <div className={styles.testSubLinks}>
                <Link
                  to="/Section"
                  className={`${styles.subLink} ${isActiveLink('/Section') ? styles.activeSub : ''}`}
                  onClick={closeAndNavigate}
                >
                  <span>Section</span>
                  {isActiveLink('/Section') && <FaArrowRight className={styles.activeArrow} />}
                </Link>
                <Link
                  to="/Questions"
                  className={`${styles.subLink} ${isActiveLink('/Questions') ? styles.activeSub : ''}`}
                  onClick={closeAndNavigate}
                >
                  <span>Questions</span>
                  {isActiveLink('/Questions') && <FaArrowRight className={styles.activeArrow} />}
                </Link>
                <Link
                  to="/Tests"
                  className={`${styles.subLink} ${isActiveLink('/Tests') ? styles.activeSub : ''}`}
                  onClick={closeAndNavigate}
                >
                  <span>Test</span>
                  {isActiveLink('/Tests') && <FaArrowRight className={styles.activeArrow} />}
                </Link>
                <div onClick={handleReportedQuestionsOverdue}>
                <Link
                  to="/reportedQstns"
                  className={`${styles.subLink} ${isActiveLink('/reportedQstns') ? styles.activeSub : ''}`}
                  onClick={closeAndNavigate}
                >
                  <span>Reported Questions</span>
                  {isActiveLink('/reportedQstns') && <FaArrowRight className={styles.activeArrow} />}
                </Link>
                  </div>
              </div>
            )}

            <Link
              to="/certificate"
              className={`${styles.menuLink} ${isActiveLink('/certificate') ? styles.active : ''}`}
              onClick={closeAndNavigate}
            >
              <span>Certificate</span>
              {isActiveLink('/certificate') && <FaArrowRight className={styles.activeArrow} />}
            </Link>

            <Link
              to="/live"
              className={`${styles.menuLink} ${isActiveLink('/live') ? styles.active : ''}`}
              onClick={closeAndNavigate}
            >
              <span>Live Video Progress</span>
              {isActiveLink('/live') && <FaArrowRight className={styles.activeArrow} />}
            </Link>

            <Link
              to="/freeVideos"
              className={`${styles.menuLink} ${isActiveLink('/freeVideos') ? styles.active : ''}`}
              onClick={closeAndNavigate}
            >
              <FaRegPlayCircle className={styles.leadIcon} />
              <span>Free Videos</span>
              {isActiveLink('/freeVideos') && <FaArrowRight className={styles.activeArrow} />}
            </Link>

            {/* Utility row */}
            <div className={styles.utilityRow}>
              <button className={styles.transcodeBtn} onClick={handleTranscode}>
                Start Transcode
              </button>
            </div>

            {/* User info & logout */}
            {user && (
              <>
                <hr className={styles.hr} />
                <div className={styles.userCard}>
                  <img className={styles.userImage} src={userImage} alt={user?.name || 'User'} />
                  <div className={styles.userMeta}>
                    <p><strong>Name:</strong> {user.name}</p>
                    <p><strong>Email:</strong> {user.username}</p>
                    <p><strong>Department:</strong> {user.department}</p>
                  </div>
                </div>
                <Button
                  variant="outline-danger"
                  className={styles.logoutBtn}
                  onClick={() => setIsLoggingOut(true)}
                >
                  Log Out
                </Button>
              </>
            )}
          </nav>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Main content (no top gap at 1024px) */}
      <div className={`${styles.contentWrap} col p-0 m-0`}>
        <Outlet />
      </div>

      {!user && <Login />}
    </div>
  );
};

export default SideBar;



// import React, { useState, useEffect } from 'react';
// import { Link, Outlet, useLocation } from 'react-router-dom';
// import styles from '../../styles/sidebar.module.css';
// import {
//   CDBSidebar,
//   CDBSidebarContent,
//   CDBSidebarHeader,
//   CDBSidebarMenu,
//   CDBSidebarMenuItem,
//   CDBSidebarFooter,
// } from 'cdbreact';
// import { Modal, Button } from 'react-bootstrap';
// import Login from '../Login/Login';
// import userImage from './user.png';
// import axios from '../../constents/axios';

// import { FaArrowRight, FaBars, FaTimes } from 'react-icons/fa';

// import { FaRegPlayCircle } from 'react-icons/fa'; 


// const SideBar = ({ user, setUser }) => {
//   const [showModal, setShowModal] = useState(false);
//   const [isLoggingOut, setIsLoggingOut] = useState(false);
//   const [isOpen, setIsOpen] = useState(false);
//   const location = useLocation();
//   const [isMobileTestOpen, setIsMobileTestOpen] = useState(false);
//   const [showMobileSidebar, setShowMobileSidebar] = useState(false);

//   const isMobile = typeof window !== 'undefined' && window.innerWidth < 1337;

//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth >= 1337) {
//         setShowMobileSidebar(false);
//       }
//     };
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const toggleDropdown = () => setIsOpen(prev => !prev);
//   const handleShow = () => setShowModal(true);
//   const handleClose = () => setShowModal(false);
//   const handleLogOut = () => setIsLoggingOut(true);

//   useEffect(() => {
//     if (isLoggingOut) {
//       localStorage.removeItem('adminLogin');
//       setUser(null);
//       setShowModal(false);
//       setIsLoggingOut(false);
//     }
//   }, [isLoggingOut]);

//   const handleTranscode = async () => {
//     try {
//       await axios.get('/transcode');
//     } catch (error) {
//       console.error('Error starting transcoding server:', error.message);
//     }
//   };

//   const isActiveLink = (path) => location.pathname === path;

//   return (
//     <div className={styles.sidebarDiv}>

//       <div className={styles.mobileHamburger}>
//         <FaBars onClick={() => setShowMobileSidebar(true)} />
//       </div>

//       {!isMobile && (

//       <CDBSidebar className={styles.sidebar}>
//         <CDBSidebarHeader prefix={<i className="fa fa-bars" />}>Admin Panel</CDBSidebarHeader>
//         <CDBSidebarContent className={styles.menuBar}>
//           <CDBSidebarMenu className={styles.menuItem}>
//             <Link to="/studentJourney" className={styles.link}>
//               <CDBSidebarMenuItem className={isActiveLink('/studentJourney') ? styles.activeItem : styles.item} icon="th-large">
//                 Student Journey
//                 {isActiveLink('/studentJourney') && <FaArrowRight fontSize={20} style={{ marginLeft: '25px' }} />}
//               </CDBSidebarMenuItem>
//             </Link>
//             <Link to="/e-books" className={styles.link}>
//               <CDBSidebarMenuItem className={isActiveLink('/e-books') ? styles.activeItem : styles.item} icon="book">
//                 E-Books
//                 {isActiveLink('/e-books') && <FaArrowRight fontSize={20} style={{ marginLeft: '80px' }} />}
//               </CDBSidebarMenuItem>
//             </Link>
//             <Link to="/convertStudentJourney" className={styles.link}>
//               <CDBSidebarMenuItem className={isActiveLink('/convertStudentJourney') ? styles.activeItem : styles.item} icon="sync">
//                 Convertion
//                 {isActiveLink('/convertStudentJourney') && <FaArrowRight fontSize={20} style={{ marginLeft: '40px' }} />}
//               </CDBSidebarMenuItem>
//             </Link>
//             <Link to="/reels" className={styles.link}>
//               <CDBSidebarMenuItem className={isActiveLink('/reels') ? styles.activeItem : styles.item} icon="play">
//                 Reels
//                 {isActiveLink('/reels') && <FaArrowRight fontSize={20} style={{ marginLeft: '40px' }} />}
//               </CDBSidebarMenuItem>
//             </Link>
//             <Link to="/events" className={styles.link}>
//               <CDBSidebarMenuItem className={isActiveLink('/events') ? styles.activeItem : styles.item} icon="bullhorn">
//                 Events
//                 {isActiveLink('/events') && <FaArrowRight fontSize={20} style={{ marginLeft: '40px' }} />}
//               </CDBSidebarMenuItem>
//             </Link>
//             <Link className={styles.link}>
//               <CDBSidebarMenuItem
//                 className={styles.item}
//                 icon="pallet"
//                 onClick={toggleDropdown}
//               >
//                 Tests
//               </CDBSidebarMenuItem>
//               {isOpen && (
//                 <div className={styles.dropdown}>
//                   <ul>
//                     <Link to="/Section" className={styles.link}>
//                       <CDBSidebarMenuItem className={isActiveLink('/Section') ? styles.activeItem : styles.item} icon="columns">
//                         Section
//                         {isActiveLink('/Section') && <FaArrowRight fontSize={20} style={{ marginLeft: '40px' }} />}
//                       </CDBSidebarMenuItem>
//                     </Link>
//                     <Link to="/Questions" className={styles.link}>
//                       <CDBSidebarMenuItem className={isActiveLink('/Questions') ? styles.activeItem : styles.item} icon="question-circle">
//                         Questions
//                         {isActiveLink('/Questions') && <FaArrowRight fontSize={20} style={{ marginLeft: '40px' }} />}
//                       </CDBSidebarMenuItem>
//                     </Link>
//                     <Link to="/Tests" className={styles.link}>
//                       <CDBSidebarMenuItem className={isActiveLink('/Tests') ? styles.activeItem : styles.item} icon="clipboard-list">
//                         Test
//                         {isActiveLink('/Tests') && <FaArrowRight fontSize={20} style={{ marginLeft: '40px' }} />}
//                       </CDBSidebarMenuItem>
//                     </Link>
//                     <Link to="/reportedQstns" className={styles.link}>
//                       <CDBSidebarMenuItem className={isActiveLink('/reportedQstns') ? styles.activeItem : styles.item} icon="question">
//                         Reported Questions
//                         {isActiveLink('/reportedQstns') && <FaArrowRight fontSize={20} style={{ marginLeft: '40px' }} />}
//                       </CDBSidebarMenuItem>
//                     </Link>
//                   </ul>
//                 </div>
//               )}
//             </Link>
//             <Link to="/certificate" className={styles.link}>
//               <CDBSidebarMenuItem className={isActiveLink('/certificate') ? styles.activeItem : styles.item} icon="certificate">
//                 Certificate
//                 {isActiveLink('/certificate') && <FaArrowRight fontSize={20} style={{ marginLeft: '40px' }} />}
//               </CDBSidebarMenuItem>
//             </Link>
//             <Link to="/live" className={styles.link}>
//               <CDBSidebarMenuItem className={isActiveLink('/live') ? styles.activeItem : styles.item} icon="video">
//                 Live Video Progress
//                 {isActiveLink('/live') && <FaArrowRight fontSize={20} style={{ marginLeft: '40px' }} />}
//               </CDBSidebarMenuItem>
//             </Link>
//               <Link to="/freeVideos" className={styles.link}>
//               <CDBSidebarMenuItem className={isActiveLink('/freeVideos') ? styles.activeItem : styles.item} >
//       <FaRegPlayCircle fontSize={20} style={{ marginRight: '40px' }} />
//                 Free Videos
//                 {isActiveLink('/freeVideos') && <FaArrowRight fontSize={20} style={{ marginLeft: '40px' }} />}
//               </CDBSidebarMenuItem>
//             </Link>
//           </CDBSidebarMenu>
//         </CDBSidebarContent>
//           <CDBSidebarFooter className={styles.footer} style={{ textAlign: 'center' }}>
//             <Link className={styles.link} onClick={handleTranscode}>
//               <CDBSidebarMenuItem className={styles.item} icon="sync">Start Transcode</CDBSidebarMenuItem>
//             </Link>
//             {user && (
//               <CDBSidebarMenu className={styles.menuItem}>
//                 <CDBSidebarMenuItem className={styles.item} icon="user" onClick={handleShow}>
//                   <strong>{user.name}</strong>
//                 </CDBSidebarMenuItem>
//               </CDBSidebarMenu>
//             )}
//           </CDBSidebarFooter>
//         </CDBSidebar>
//       )}

//       <div className={styles.OutletDiv}>
//         <div className="col py-3 p-0 m-0" style={{ overflow: 'hidden' }}>
//           <Outlet />
//         </div>
//       </div>

//       {/* Desktop Modal */}
//       {!isMobile && user && (
//         <Modal show={showModal} onHide={handleClose} centered>
//           <Modal.Header closeButton>
//             <Modal.Title>Profile</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <div className='row'>
//               <div className='col-md-3'>
//                 <img className={styles.userImageDiv} src={userImage} alt={user.name} />
//               </div>
//               <div className='col-md-9'>
//                 <p>Name: {user.name}</p>
//                 <p>Email: {user.username}</p>
//                 <p>Department: {user.department}</p>
//               </div>
//             </div>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button variant="outline-danger" onClick={handleLogOut}>Log Out</Button>
//           </Modal.Footer>
//         </Modal>
//       )}

//       {!user && <Login />}

//       {/* Mobile/Tablet Sidebar Modal */}
//       {isMobile && (
//         <Modal show={showMobileSidebar} onHide={() => setShowMobileSidebar(false)} fullscreen centered className={styles.mobileSidebarModal}>
//           <button className={styles.mobileSidebarClose} onClick={() => setShowMobileSidebar(false)}>
//             <FaTimes />
//           </button>
//           <Modal.Body>
//             <h5>Admin Panel</h5>
//             <div className={styles.dropdown}>
//               <Link to="/studentJourney" onClick={() => setShowMobileSidebar(false)}>Student Journey</Link>
//               <Link to="/e-books" onClick={() => setShowMobileSidebar(false)}>E-Books</Link>
//               <Link to="/convertStudentJourney" onClick={() => setShowMobileSidebar(false)}>Conversion</Link>
//               <Link to="/reels" onClick={() => setShowMobileSidebar(false)}>Reels</Link>
//               <Link to="/events" onClick={() => setShowMobileSidebar(false)}>Events</Link>

//               <div className={styles.testDropDownWrapper} onClick={() => setIsMobileTestOpen(!isMobileTestOpen)}>
//                 <span className={styles.testDropDownText}>Tests</span>
//                 <span className={styles.testDropDownIcon}>{isMobileTestOpen ? '▲' : '▼'}</span>
//               </div>

//               {isMobileTestOpen && (
//                 <div className={styles.testSubLinks}>
//                   <Link to="/Section" onClick={() => setShowMobileSidebar(false)}>Test Section</Link>
//                   <Link to="/Questions" onClick={() => setShowMobileSidebar(false)}>Questions</Link>
//                   <Link to="/Tests" onClick={() => setShowMobileSidebar(false)}>Test</Link>
//                   <Link to="/reportedQstns" onClick={() => setShowMobileSidebar(false)}>Reported Questions</Link>
//                 </div>
//               )}

//               <Link to="/certificate" onClick={() => setShowMobileSidebar(false)}>Certificate</Link>
//               <Link to="/live" onClick={() => setShowMobileSidebar(false)}>Live Video Progress</Link>
//               <Link to="/freeVideos" onClick={() => setShowMobileSidebar(false)}>Free Video</Link>
//               {/* <hr />
//               <Link onClick={handleTranscode}>Start Transcode</Link> */}
//               {user && (
//                 <>
//                   <hr />
//                   <div className='border p-4 border-light rounded' style={{ textAlign: 'left' }}>
//                 <p><strong>Name:</strong> {user.name}</p>
//                 <p><strong>Email:</strong> {user.username}</p>
//                 <p><strong>Department:</strong> {user.department}</p>
//               </div>
//                 </>
//               )}
//               <Button variant="outline-light" style={{ width: '90%' }} onClick={handleLogOut}>Log Out</Button>
//               <br />
//             </div>
//           </Modal.Body>
//         </Modal>
//       )}
//     </div>
//   );
// };

// export default SideBar;
